import { useState, type ReactNode } from 'react';
import { Icon } from '../lib/icons.js';
import { Ambient } from '../components/ui.js';

/**
 * Shown when the device has no network at all. The app shell itself is
 * precached, so a guest who opens it on a dead connection still gets this
 * rather than the browser's error page.
 */
export function Offline({ onRetry }: { onRetry?: () => void }): ReactNode {
  const [trying, setTrying] = useState(false);

  return (
    <>
      <Ambient />
      <main className="codepad">
        <div className="glass codepad-inner">
          <span className="hero-glyph" style={{ margin: '0 auto var(--space-4)' }}>
            <Icon name="wifi-off" size={22} />
          </span>
          <h1>No connection</h1>
          <p>
            The app is installed and ready, but your phone is offline. It needs the internet — or the
            house wifi — to reach the house.
          </p>
          <button
            type="button"
            className="btn btn-primary btn-block"
            disabled={trying}
            onClick={() => {
              setTrying(true);
              if (onRetry) onRetry();
              else location.reload();
              window.setTimeout(() => setTrying(false), 1500);
            }}
          >
            <Icon name="wifi" size={17} />
            {trying ? 'Trying…' : 'Try again'}
          </button>
          <p style={{ marginTop: 'var(--space-5)', fontSize: 12.5, marginBottom: 0 }}>
            It will reconnect on its own as soon as you have signal.
          </p>
        </div>
      </main>
    </>
  );
}
